import {NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';

import {ViewModule} from 'app/views/view.module';

import {DomainBillingComponent} from "./domain_billing/domain_billing.component";
import {MoneyDetailsComponent} from "./domain_billing/details/money_details/money_details.component";
import {AttachDomainDetailsComponent} from "./domain_actions/details/attach_domain_details/attach_domain_details.component";
import {DetailsComponent} from "./domain_actions/details/details/details.component";
import {PaidDetailsComponent} from "./domain_billing/details/paid_details/paid_details.component";
import {SaveContactDetailsComponent} from "./domain_actions/details/save_contact_details/save_contact_details.component";
import {DomainActionsComponent} from "./domain_actions/domain_actions.component";
import { ExpiredDomainsComponent } from './expired-domains/expired-domains.component';
import {DepartedTableDetail} from "./expired-domains/departed_table_detail";
import {BuyingChartDetail} from "./expired-domains/BuyingChartDetail";
import {DomainZonesComponent} from "./domain_zones/domain_zones.component";
import {DomainZonesDetailsComponent} from "./domain_zones/details/domain_zones_details.component";
import { DomainsService } from "./domains.service";

@NgModule({
	imports: [
		ViewModule,
		HttpClientModule
	],
	declarations: [
		DomainBillingComponent,
		DomainActionsComponent,
		DomainZonesComponent,
		MoneyDetailsComponent,
		AttachDomainDetailsComponent,
		DetailsComponent,
		PaidDetailsComponent,
		SaveContactDetailsComponent,
		ExpiredDomainsComponent,
		DepartedTableDetail,
		BuyingChartDetail,
		DomainZonesDetailsComponent
	],

	providers: [
		DomainsService,
	],
	entryComponents: [
		MoneyDetailsComponent,
		AttachDomainDetailsComponent,
		DetailsComponent,
		PaidDetailsComponent,
		SaveContactDetailsComponent,
		DepartedTableDetail,
		BuyingChartDetail,
		DomainZonesDetailsComponent
	]
})
export class DomainsModule {}
